module.exports = "# Sizzle\n\n## Content\n\n### Activity: Create a Poster\n\n## Notes\nActivity: Create a Poster\n\nActivity instructions on next slide.\n\n\n# Instructions\n\n## Content\n\n### Instructions\n* Each team member draws a poster to take home to remind their family about specific ways to reduce water pollution.\n* See your mission book for ways to reduce water pollution, and choose at least two for your poster.\n* Apprentices get points for completing their poster.\n\n## Notes\n&nbsp;\n"


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/sections/30_classActivity/level3_poster.md
// module id = 1702
// module chunks = 2